import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  justify-content: center;
  // min-width: 188px;
  min-width: 54px;
  max-width: 55px;
  height: 50px;
  margin: 10px;
  margin-right: 3px;
  border: 1px solid #cac4d0;
  background-color: #ffffff;
  cursor: pointer;
  border: ${(props) => (props.isSelected ? "2px" : "1px")} solid
    ${(props) => (props.isSelected ? "#625B71" : "#EAECF0")};
  background-color: ${(props) => (props.isSelected ? "#F7F2FA" : "#ffffff")};
  opacity: ${(props) => (props.isActive ? 1 : 0.5)};
`;

export const AlignmentImage = styled.img`
  width: 32px;
  height: 32px;
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-position: center;
`;
